import { graphql, readInlineData } from 'react-relay';

import { showPricingGuidance as showPricingGuidanceHelper } from 'dibs-pricing-guidance/exports/showPricingGuidance.ts';

import { type getPdpEstimateSimilarSold_viewer$key } from './__generated__/getPdpEstimateSimilarSold_viewer.graphql.ts';
import { type getPdpEstimateSimilarSold_item$key } from './__generated__/getPdpEstimateSimilarSold_item.graphql.ts';

const viewerFragment = graphql`
    fragment getPdpEstimateSimilarSold_viewer on Viewer @inline {
        similarSoldItemsResults: similarSoldItems(itemId: $itemId, first: 0)
            @include(if: $isEstimateSimilarSoldVariant) {
            totalResults
        }
    }
`;

const itemFragment = graphql`
    fragment getPdpEstimateSimilarSold_item on Item @inline {
        ...showPricingGuidance_item
    }
`;

const MIN_SIMILAR_SOLD_ITEMS = 3;

export const getHasEnoughSimilarSoldItems = ({
    viewer: viewerRef,
}: {
    viewer: getPdpEstimateSimilarSold_viewer$key | null;
}): boolean => {
    const viewer = readInlineData(viewerFragment, viewerRef);
    const totalResults = viewer?.similarSoldItemsResults?.totalResults || 0;

    return totalResults >= MIN_SIMILAR_SOLD_ITEMS;
};

export const getShowPdpEstimateInTab = ({
    viewer,
    item: itemRef,
    currency,
    isPdpEstimateSimilarSoldTestVariant,
}: {
    viewer: getPdpEstimateSimilarSold_viewer$key | null;
    item?: getPdpEstimateSimilarSold_item$key | null;
    currency: string;
    isPdpEstimateSimilarSoldTestVariant: boolean;
}): boolean => {
    const item = readInlineData(itemFragment, itemRef);

    const showPricingGuidance = showPricingGuidanceHelper({ item: item || null, currency });
    const hasEnoughSimilarSoldItems = getHasEnoughSimilarSoldItems({ viewer });

    return (
        showPricingGuidance && (!isPdpEstimateSimilarSoldTestVariant || !hasEnoughSimilarSoldItems)
    );
};

export const getShowPdpEstimateSimilarSoldSection = ({
    viewer,
    item: itemRef,
    currency,
}: {
    viewer: getPdpEstimateSimilarSold_viewer$key | null;
    item: getPdpEstimateSimilarSold_item$key | null;
    currency: string;
}): boolean => {
    const item = readInlineData(itemFragment, itemRef);

    const showPricingGuidance = showPricingGuidanceHelper({ item: item || null, currency });
    const hasEnoughSimilarSoldItems = getHasEnoughSimilarSoldItems({ viewer });

    return showPricingGuidance && hasEnoughSimilarSoldItems;
};
